import { useTranslation } from '@/i18n';
import { Heading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type Props = {
  children: ReactNode;
};

export const Header: FC<Props> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles['aiServiceHeaderRow'])}>
      <Heading as='h2' weight='normal' size='16px'>
        {t('ai_service_setting.settings_heading')}
      </Heading>
      <div className={cx(styles['aiServiceHeaderAction'])}>{children}</div>
    </div>
  );
};

Header.displayName = 'ApAiServiceSettingsHeader';
